import { Helmet } from 'react-helmet';
import { isPrerender } from '@medifind/utils';
import { htmlToLDJSON } from '@medifind/utils';
export const FAQPageJsonLd = ({ mainEntity }) => {
  return (
    <Helmet defer={!isPrerender}>
      {mainEntity && mainEntity.length > 0 && (
        <script type="application/ld+json">
          {JSON.stringify({
            '@context': 'http://schema.org/',
            '@type': 'FAQPage',
            mainEntity: mainEntity
              .map(({ questionName, acceptedAnswerText, title, content }) => {
                return {
                  '@type': 'Question',
                  name: htmlToLDJSON(questionName ? questionName : title),
                  acceptedAnswer: {
                    '@type': 'Answer',
                    text: htmlToLDJSON(acceptedAnswerText ? acceptedAnswerText : content),
                  },
                };
              })
              .filter((d) => d.name && d.acceptedAnswer.text),
          })}
        </script>
      )}
    </Helmet>
  );
};
